import { useCallback, useEffect, useRef, useState } from 'react';

export function useToast() {
  const [msg, setMsg] = useState('');
  const timer = useRef<number | undefined>(undefined);

  const toast = useCallback((m: string) => {
    setMsg(m);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setMsg(''), 2600);
  }, []);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const toastEl = (
    <div className={`toast${msg ? ' show' : ''}`} role="status" aria-live="polite">
      {msg}
    </div>
  );

  return { toast, toastEl };
}

export type Toast = (m: string) => void;
